import { render, staticRenderFns } from "./equityWebsiteResult.vue?vue&type=template&id=28294158&scoped=true"
import script from "./equityWebsiteResult.vue?vue&type=script&lang=js"
export * from "./equityWebsiteResult.vue?vue&type=script&lang=js"
import style0 from "./equityWebsiteResult.vue?vue&type=style&index=0&id=28294158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28294158",
  null
  
)

export default component.exports